var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-page-&-Service-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-5",
    transform: "translate(-349.000000, -730.000000)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349,743.297937 C350.634911,744.372876 352.576036,745 354.660947,745 C361.517456,745 365.389941,739.061893 365.157396,733.735437 C365.878107,733.202063 366.504734,732.534891 367,731.774879 C366.336982,732.076153 365.625148,732.280036 364.878698,732.371056 C365.641124,731.903216 366.226923,731.161408 366.502071,730.275789 C365.788462,730.709951 364.997633,731.025789 364.157988,731.195085 C363.483432,730.459648 362.523964,730 361.461538,730 C359.078402,730 357.326331,732.280036 357.865089,734.649272 C354.795858,734.491808 352.074556,732.983617 350.254142,730.692658 C349.286686,732.394721 349.751775,734.621966 351.39645,735.748786 C350.791124,735.728762 350.221302,735.557646 349.723373,735.274575 C349.683432,737.02943 350.909172,738.6696 352.685207,739.035498 C352.165089,739.181129 351.596154,739.213896 351.018343,739.100121 C351.486982,740.605583 352.851183,741.699636 354.467456,741.730583 C352.915089,742.978459 350.959763,743.535498 349,743.297937",
    id: "Fill-16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.9bb9515b6de72b553a3620a589291dd0.svg";
export { ForwardRef as ReactComponent };